import Vue from 'vue';
import Router from 'vue-router';

import routes from './routes';

import authMiddleware from './middlewares/auth';
import guestMiddleware from './middlewares/guest';

Vue.use(Router);

const router = new Router({ routes });

router.beforeEach(authMiddleware);
router.beforeEach(guestMiddleware);

export default router;
